import React from 'react';
import { motion } from 'framer-motion';
const stats = [{
  number: '6',
  label: 'tomów gotowych PDF'
}, {
  number: '40',
  label: 'tygodni planów treningowych'
}, {
  number: '200+',
  label: 'ćwiczeń w bibliotece'
}, {
  number: '8',
  label: 'grup wiekowych U6-U13'
}, {
  number: '6',
  label: 'bonusów dodatkowych'
}, {
  number: '0',
  label: 'miesięcznych opłat'
}];
export function Numbers() {
  return <section className="w-full py-12 md:py-20 px-4 md:px-6" style={{
    background: '#0F1F3D'
  }} data-id="element-182">
      <div className="max-w-6xl mx-auto" data-id="element-183">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-2xl md:text-3xl lg:text-4xl font-display font-bold text-center text-white mb-8 md:mb-12" data-id="element-184">
          W liczbach:
        </motion.h2>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-8" data-id="element-185">
          {stats.map((stat, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.08
        }} className="text-center" data-id="element-186">
              <div className="font-display font-bold text-5xl sm:text-6xl md:text-7xl leading-none mb-2 tabular-nums" style={{
            color: '#F5A623'
          }} data-id="element-187">
                {stat.number}
              </div>
              <p className="text-sm md:text-base text-white/90 leading-tight" data-id="element-188">
                {stat.label}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}